import {inject} from 'aurelia-framework';  
import { HttpClient } from 'aurelia-http-client';
export class VideoCaptureLogAPI {


    constructor(){
       
    }
   

    log(data) {

       

        var http = new HttpClient().configure(x => {
             x.withHeader('Content-Type', 'application/json')
             .withInterceptor({
                
          
                requestError(error) {
                    return null;
                },
          
                
          
                responseError(error) {
                    return null;
                }
              });
           
            });

        http.post('api/videocapturelog/log', data).then(function(response){
            return null;
        }).catch((error)=>{
            return null;
        }
        );



    }

   

}